import { render, staticRenderFns } from "./find_password.vue?vue&type=template&id=18bdfa05"
import script from "./find_password.vue?vue&type=script&lang=js"
export * from "./find_password.vue?vue&type=script&lang=js"
import style0 from "./find_password.vue?vue&type=style&index=0&id=18bdfa05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports